import { computed, linkedSignal, type Signal } from '@angular/core';

export function createSuggestionPages<T>(
    suggestions: Signal<readonly T[]>,
    pageSize: Signal<number> = computed(() => 4)
) {
    const size = computed(() => Math.max(1, Math.floor(pageSize())));
    const page = linkedSignal({
        source: () => ({ suggestions: suggestions(), size: size() }),
        computation: () => 0,
    });
    const totalPages = computed(() =>
        Math.max(1, Math.ceil(suggestions().length / size()))
    );
    return {
        visible: computed(() =>
            suggestions().slice(page() * size(), (page() + 1) * size())
        ),
        currentPage: computed(() => page() + 1),
        totalPages,
        select: (selected: number) =>
            page.set(Math.max(0, Math.min(selected - 1, totalPages() - 1))),
        previous: () =>
            page.update(
                (current) => (current - 1 + totalPages()) % totalPages()
            ),
        next: () => page.update((current) => (current + 1) % totalPages()),
    };
}
